import { CCarousel, CCarouselItem } from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'
import { useRef } from 'react'
import { Swiper, SwiperSlide } from 'src/business/components/swiper/Swiper'
import { register } from 'swiper/element/bundle'
import {
  GoalImage,
  GoalSlide,
  GoalSlideTitle,
  GoalsCard,
  GoalsProgressContainer,
  GoalsProgressTextHeading,
  GoalsProgressTextSubHeading,
  GoalsSubtext,
} from './styledComponents'
import { Button } from '@mui/material'
import 'swiper/css'
import './goalsCarouselStyles.css'
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import { defaultBgImgId } from 'src/consumer/constants'

register()

function FrontOfCard({ data }) {
  const progress = 30
  return (
    <GoalSlide>
      <GoalsCard>
        <GoalImage src={getImageLink(data?.coverIcon, defaultBgImgId)} />
        <GoalsSubtext>
          {data?.sessions || '2'} Sessions • {data?.minutes || '305'} mins
        </GoalsSubtext>
        <GoalSlideTitle>{data?.name || data?.title || 'In the Present'}</GoalSlideTitle>
      </GoalsCard>
      <GoalsProgressContainer>
        <CircularProgressbarWithChildren value={progress}>
          <div className="p-2">
            <GoalsProgressTextHeading>{data?.progress || 34}%</GoalsProgressTextHeading>
            <GoalsProgressTextSubHeading>Complete</GoalsProgressTextSubHeading>
          </div>
        </CircularProgressbarWithChildren>
      </GoalsProgressContainer>
    </GoalSlide>
  )
}

export default function GoalCarousel({ items }) {
  return (
    <>
      {/* <swiper-container
        ref={swiperElRef}
        navigation="true"
        centered-slides="true"
        space-between={30}
        initial-slide={3}
        autoplay-delay="2000"
        autoplay-disable-on-interaction="true"
        slides-per-view={`${slidesPerView}`}
        style={{ width: '100%' }}
      >
        {items.map((item, index) => (
          <swiper-slide key={index}>
            <GoalSlide>
              <FrontOfCard data={item} />
            </GoalSlide>
          </swiper-slide>
        ))}
      </swiper-container> */}
      <div className="goals-carousel-swiper" style={{ width: '100%' }}>
      <Swiper
        navigation={true}
        centeredSlides={false}
        initialSlide={0}
        autoplayDelay="2000"
        slidesPerView={1}
        spaceBetween={10}
        autoplayDisableOnInteraction={true}
        style={{ width: '100%' }}
        breakpoints={{
          1: {
            slidesPerView: 1,
            spaceBetween: 12,
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
          1500: {
            slidesPerView: 4,
            spaceBetween: 28,
          },
        }}
      >
        {items.map((item, index) => (
          <SwiperSlide key={index}>
            <FrontOfCard data={item} />
          </SwiperSlide>
        ))}
      </Swiper>
      </div>
    </>
  )
}
